const layout = {
  xs: 12
};

const subCategory = {
  name: {
    layout: {
      ...layout
    },
    type: "text",
    label: "Name",
    component: "text"
  },
  children: {
    layout: {
      ...layout
    },
    type: "string",
    label: "Product",
    relation: {
      ref: "classification",
      fields: ["name"]
    },
    component: ""
  }
};

export default {
  ref: "classification",
  title: "Classification",
  id: "classification",
  type: "object",
  properties: {
    name: {
      layout: {
        ...layout
      },
      type: "string",
      label: "Name",
      component: "text"
    },
    order: {
      layout: {
        ...layout
      },
      type: "number",
      label: "Order",
      component: "number"
    },
    // parentId: {
    //   layout: {
    //     ...layout
    //   },
    //   type: 'string',
    //   label: 'Parent',
    //   relation: {
    //     ref: 'classification',
    //     fields: ['name']
    //   },
    //   component: 'selectRelational'
    // },
    image: {
      layout: {
        ...layout
      },
      type: "array",
      label: "Image",
      component: "file"
    },
    children: {
      layout: {
        ...layout
      },
      type: "array",
      label: "Sub Categories",
      component: "repeater",
      relation: {
        ref: "classification",
        fields: ["name"]
      },
      properties: {
        id: {
          layout: {
            ...layout
          },
          type: "string",
          label: "ID",
          hidden: true,
          component: "shortId"
        },
        name: {
          layout: {
            ...layout
          },
          type: "string",
          label: "Name",
          component: "text"
        },

        image: {
          layout: {
            ...layout
          },
          type: "array",
          label: "Image",
          component: "file"
        },
        children: {
          layout: {
            ...layout
          },
          type: "array",
          label: "Level 2",
          component: "repeater",
          properties: {
            id: {
              layout: {
                ...layout
              },
              type: "string",
              label: "ID",
              hidden: true,
              component: "shortId"
            },
            name: {
              layout: {
                ...layout
              },
              type: "string",
              label: "Name",
              component: "text"
            },
            image: {
              layout: {
                ...layout
              },
              type: "array",
              label: "Image",
              component: "file"
            },
            children: {
              layout: {
                ...layout
              },
              type: "array",
              label: "Level 3",
              component: "repeater",
              properties: {
                id: {
                  layout: {
                    ...layout
                  },
                  type: "string",
                  label: "ID",
                  hidden: true,
                  component: "shortId"
                },
                name: {
                  layout: {
                    ...layout
                  },
                  type: "string",
                  label: "Name",
                  component: "text"
                },
                image: {
                  layout: {
                    ...layout
                  },
                  type: "array",
                  label: "Image",
                  component: "file"
                },
                children: {
                  layout: {
                    ...layout
                  },
                  type: "array",
                  label: "Level 4",
                  component: "repeater",
                  properties: {
                    id: {
                      layout: {
                        ...layout
                      },
                      type: "string",
                      label: "ID",
                      hidden: true,
                      component: "shortId"
                    },
                    name: {
                      layout: {
                        ...layout
                      },
                      type: "string",
                      label: "Name",
                      component: "text"
                    },
                    image: {
                      layout: {
                        ...layout
                      },
                      type: "array",
                      label: "Image",
                      component: "file"
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

export const mockData = {
  name: "Woot"
};
